class DefaultTextContainerController {
  constructor($stateParams, adminService, loadingService) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.adminService = adminService;
    this.loadingService = loadingService;
    
    this.errMsg = '';
    this.defaultTexts = {};

    this.loadDefaultTexts();
  }

  loadDefaultTexts() {
    const ctrl = this;

    ctrl.loadingService.showLoading('defaultTexts', 'Loading Default Texts ...');

    ctrl.adminService.listDefaultTexts(ctrl.$stateParams.locationId)
      .then(response => {
        this.defaultTexts = response.data;
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('defaultTexts');
      });
  }

  saveChanges() {
    const ctrl = this;

    ctrl.loadingService.showLoading('defaultTexts', 'Saving Changes ...');

    ctrl.adminService.updateDefaultTexts(ctrl.$stateParams.locationId, ctrl.defaultTexts)
      .then(response => {
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('defaultTexts');
      });    
  }
}

export default DefaultTextContainerController;



// WEBPACK FOOTER //
// ./client/app/components/admin/defaultTextManagement/defaultTextContainer/defaultTextContainer.controller.js